import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';

import ApiFactory from '@/api/apiFactory';
import i18n, { updateLanguageStrings } from '@/i18n';
import localizeStubs from '@/api/stubs';

const translateRepository = ApiFactory.get('translate');

interface ItranslatedStrings {
  [dynamic: string]: string;
}
class RootState {
  translatedStrings: ItranslatedStrings = {};
}

class RootGetters extends Getters<RootState> {}

class RootMutations extends Mutations<RootState> {
  loadStubs(stubsList: string[]) {
    updateLanguageStrings(i18n.locale, localizeStubs(i18n.locale, stubsList));
  }
}

class RootActions extends Actions<
  RootState,
  RootGetters,
  RootMutations,
  RootActions
> {
  getAsyncData(payload: { code: string; keys: Array<string> }) {
    return new Promise((resolve, reject) => {
      translateRepository.get(payload.code, payload.keys)
        .then((repo) => {
          updateLanguageStrings(payload.code, repo);
          resolve(repo);
        })
        .catch((e) => {
          reject(e);
        });
    });
  }
}

// Экспорт модуля
export const TranslateModule = new Module({
  state: RootState,
  getters: RootGetters,
  mutations: RootMutations,
  actions: RootActions,
});

export const TranslateModuleMapper = createMapper(TranslateModule);
